@if (version && environmentName !== 'prod') {
  <ui-label
    [config]="labelConfig"
    [cdkCopyToClipboard]="version"
    (cdkCopyToClipboardCopied)="onCopied()"
  >
    {{ version }}
  </ui-label>
}
